/** 
 * 暂时不写注释
 */

import nfToast from './nfToast.vue'
export default nfToast